import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { addYupCustomMethods } from '@demand-iq/core';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { App } from '@/App';
import '@/i18n';
import '@/index.css';
import { loadPostHog } from '@/utils/posthog';

loadPostHog();

addYupCustomMethods();

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </StrictMode>
  );
}
